import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/landing/creator-challenge-logo.svg'
import _imports_1 from '@/assets/images/landing/curve-w.svg'
import _imports_2 from '@/assets/images/landing/learn.svg'
import _imports_3 from '@/assets/images/landing/coin-star.svg'
import _imports_4 from '@/assets/images/landing/post.svg'
import _imports_5 from '@/assets/images/landing/sponsoring.svg'
import _imports_6 from '@/assets/icon/icon-circle-star.svg'
import _imports_7 from '@/assets/icon/icon-check-data-b-light.svg'
import _imports_8 from '@/assets/icon/icon-cut-ribbon.svg'
import _imports_9 from '@/assets/icon/icon-start.svg'
import _imports_10 from '@/assets/icon/icon-activity.svg'
import _imports_11 from '@/assets/icon/icon-trophy.svg'
import _imports_12 from '@/assets/icon/icon-calendar.svg'
import _imports_13 from '@/assets/images/landing/opening-img.svg'
import _imports_14 from '@/assets/images/landing/opening-img-i.svg'
import _imports_15 from '@/assets/images/landing/opening-img-m.svg'
import _imports_16 from '@/assets/images/landing/register-img.svg'
import _imports_17 from '@/assets/images/landing/register-img-m.svg'
import _imports_18 from '@/assets/images/landing/green-ribbon.svg'
import _imports_19 from '@/assets/images/landing/weekly-reward.svg'
import _imports_20 from '@/assets/images/landing/weekly-reward-m.svg'
import _imports_21 from '@/assets/images/landing/reward-1-10.svg'
import _imports_22 from '@/assets/images/landing/reward-11-70.svg'
import _imports_23 from '@/assets/icon/amway-logo.svg'
import _imports_24 from '@/assets/icon/icon-phone.svg'
import _imports_25 from '@/assets/oval.svg'


const _hoisted_1 = {
  class: "popup-show",
  style: { width: '100%', height: '100%', overflow: 'hidden' }
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"button-sticky mobile\"></div><section class=\"container\"><div class=\"banner\"><div class=\"banner-content\"><img src=\"" + _imports_0 + "\" alt=\"Amway Creator Challenge\"></div></div></section><section class=\"first-section\"><img src=\"" + _imports_1 + "\" class=\"curve\"><div class=\"container\" id=\"activity\"><div class=\"section-title\" style=\"margin-top:-85px;padding-top:96px;\"><span>ครีเอเตอร์ ชาเลนจ์ 2022</span></div><div class=\"row mt-16 mx-0\"><div class=\"activity-content\"><img src=\"" + _imports_2 + "\" class=\"activity-img\"><div class=\"activity-detail\"><div class=\"ad-text\"> พัฒนาทักษะการขายระดับเริ่มต้นสู่ระดับมือโปร <br>โดยมีเนื้อหาการเป็น <b>ครีเอเตอร์,การขาย และการสปอนเซอร์</b><br>ผ่านการเรียนออนไลน์ทุกสัปดาห์ </div><div class=\"ad-point mobile\"><img src=\"" + _imports_3 + "\"><div class=\"ad-point-text\"> หากท่านเรียนจบ 1 บทเรียน <br><span>จะได้รับ 2 คะแนน ต่อบทเรียน</span></div></div></div></div><div class=\"activity-content\"><img src=\"" + _imports_4 + "\" class=\"activity-img\"><div class=\"activity-detail\"><div class=\"ad-text\"> โพสต์คอนเทนต์บนโซเชียลมีเดียของนักธุรกิจแอมเวย์ <br>กำหนดให้โพสต์บน <b>เฟซบุ๊ก เพจ หรือ อินสตาแกรม ครีเอเตอร์</b><br>โดยทำคอนเทนต์จากผลิตภัณฑ์นิวทริไลท์ 3 โพสต์ ต่อสัปดาห์ <br>พร้อมติดแฮชแท็กบังคับ <b>#A7070challenge #Nutrilite</b><br>และอีก 1 แฮชแท็ก จะแจ้งให้ทราบในแต่ละสัปดาห์ </div><div class=\"ad-point mobile\"><img src=\"" + _imports_3 + "\"><div class=\"ad-point-text\"> หากท่านโพสต์ครบ 3 โพสต์ <br><span>จะได้รับคะแนน 3 คะแนน</span></div></div></div></div><div class=\"activity-content\"><img src=\"" + _imports_5 + "\" class=\"activity-img\"><div class=\"activity-detail\"><div class=\"ad-text\"> ขยายเครือข่ายครอบครัวแอมเวย์โดยการ <br><b>สปอนเซอร์นักธุรกิจแอมเวย์</b> หรือ <b>สปอนเซอร์สมาชิก</b><br>พร้อมกับ <b>สร้างยอดสั่งซื้อผลิตภัณฑ์ในกลุ่มนิวทริไลท์</b></div><div class=\"ad-point mobile\"><img src=\"" + _imports_3 + "\"><div class=\"ad-point-text\"> สปอนเซอร์นักธุรกิจแอมเวย์ <span>จะได้รับคะแนน 5 คะแนน</span><br>สปอนเซอร์สมาชิกแอมเวย์ <span>จะได้รับคะแนน 3 คะแนน</span></div></div></div></div></div><div class=\"row mx-0 desktop\"><div class=\"activity-content\"><div class=\"ad-point\"><img src=\"" + _imports_3 + "\"><div class=\"ad-point-text\"> หากท่านเรียนจบ 1 บทเรียน <br><span>จะได้รับ 2 คะแนน ต่อบทเรียน</span></div></div></div><div class=\"activity-content\"><div class=\"ad-point\"><img src=\"" + _imports_3 + "\"><div class=\"ad-point-text\"> หากท่านโพสต์ครบ 3 โพสต์ <br><span>จะได้รับคะแนน 3 คะแนน</span></div></div></div><div class=\"activity-content\"><div class=\"ad-point\"><img src=\"" + _imports_3 + "\"><div class=\"ad-point-text\"> สปอนเซอร์นักธุรกิจแอมเวย์ <span>จะได้รับคะแนน 5 คะแนน</span><br>สปอนเซอร์สมาชิกแอมเวย์ <span>จะได้รับคะแนน 3 คะแนน</span></div></div></div></div><div class=\"button-section\" style=\"padding:0 24px;\"><a><button type=\"button\" class=\"btn-red\"><div><img src=\"" + _imports_6 + "\" width=\"34px\" height=\"34px\" style=\"margin-right:12px;\"> รายละเอียดการได้รับคะแนน </div></button></a></div></div></section><section id=\"activity-lists\" style=\"margin-top:-84px;padding-top:84px;\"><div class=\"activity-lists-section\"><div class=\"container\"><div class=\"section-title\">ตารางกิจกรรม</div><div class=\"row mx-0 desktop\" style=\"justify-content:center;margin-top:65px;\"><div class=\"activity-lists\"><img src=\"" + _imports_7 + "\"><div class=\"activity-lists-date\">12-20 ก.พ.</div><div class=\"activity-lists-text\">สมัครเข้าร่วมกิจกรรม</div></div><div class=\"activity-lists\"><img src=\"" + _imports_8 + "\"><div class=\"activity-lists-date\">26 ก.พ.</div><div class=\"activity-lists-text\">กิจกรรมเปิดตัวการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_9 + "\"><div class=\"activity-lists-date\">5 มี.ค.</div><div class=\"activity-lists-text\">เริ่มการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_10 + "\"><div class=\"activity-lists-date\">13 พ.ค.</div><div class=\"activity-lists-text\">จบการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_11 + "\"><div class=\"activity-lists-date\">28 พ.ค.</div><div class=\"activity-lists-text\">ประกาศผลผู้ชนะเลิศ</div></div></div><div class=\"row mx-0 mobile\" style=\"justify-content:flex-start;margin-top:65px;\"><div class=\"activity-lists\"><img src=\"" + _imports_7 + "\"><div class=\"activity-lists-date\">12-20 ก.พ.</div><div class=\"activity-lists-text\">สมัครเข้าร่วมกิจกรรม</div></div><div class=\"activity-lists\"><img src=\"" + _imports_8 + "\"><div class=\"activity-lists-date\">26 ก.พ.</div><div class=\"activity-lists-text\"> กิจกรรมเปิดตัว <br>การแข่งขัน </div></div><div class=\"activity-lists\"><img src=\"" + _imports_10 + "\"><div class=\"activity-lists-date\">13 พ.ค.</div><div class=\"activity-lists-text\">จบการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_9 + "\"><div class=\"activity-lists-date\">5 มี.ค.</div><div class=\"activity-lists-text\">เริ่มการแข่งขัน</div></div><div class=\"activity-lists\"><img src=\"" + _imports_11 + "\"><div class=\"activity-lists-date\">28 พ.ค.</div><div class=\"activity-lists-text\"> ประกาศผล <br>ผู้ชนะเลิศ </div></div></div><div class=\"button-section\" style=\"margin-top:40px;padding:0 24px;\"><a><button type=\"button\" class=\"btn-red\"><div><img src=\"" + _imports_12 + "\" width=\"34px\" height=\"34px\" style=\"margin-right:12px;\"> ตารางแข่งขันและประกาศผล </div></button></a></div></div></div><div class=\"opening-section\"><div class=\"container\"><div style=\"position:relative;\"><div class=\"section-title\">พบกับกิจกรรม</div><div style=\"font-size:32px;font-weight:700;line-height:32px;text-align:center;color:#39a767;\">เปิดตัวการแข่งขัน</div><img src=\"" + _imports_13 + "\" class=\"opening-image\"><img src=\"" + _imports_14 + "\" class=\"opening-image-i\"><img src=\"" + _imports_15 + "\" class=\"opening-image-m\"></div></div></div></section>", 4)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("section", {
  id: "register",
  style: {"margin-top":"-84px","padding-top":"84px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "register-section" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "วิธีสมัครเข้าร่วมการแข่งขัน"),
      /*#__PURE__*/_createElementVNode("div", { class: "register-img" }, [
        /*#__PURE__*/_createElementVNode("img", { src: _imports_16 })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "register-img-m" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_17,
          width: "100%"
        })
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "register-text" }, [
        /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"668px"} }, [
          /*#__PURE__*/_createElementVNode("b", null, "หัวหน้าทีม"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* ดํารงคุณสมบัติเป็นนักธุรกิจแอมเวย์ระดับบรอนซ์ที่ได้รับรางวัล บรอนซ์บิวเดอร์อย่างน้อย 1 ครั้ง นับตั้งแต่เดือนกันยายน 2563 ถึง มกราคม 2565 หรือ ดํารงคุณสมบัติเป็นนักธุรกิจแอมเวย์ระดับเข็มเงินและสูงขึ้นไป ภายในเดือน มกราคม 2565 "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("b", null, "สมาชิกทีม"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* นักธุรกิจแอมเวย์ "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* สมาชิกในกลุ่มทุกท่านจะต้องมีบัญชี "),
          /*#__PURE__*/_createElementVNode("b", null, "เฟซบุ๊ก เพจ หรือ อินสตาแกรม ครีเอเตอร์"),
          /*#__PURE__*/_createTextVNode(" เพื่อใช้ในการทำกิจกรรม โดยเลือกได้ 1 แพลตฟอร์มเท่านั้น และไม่อนุญาตให้เปลี่ยนแพลตฟอร์มระหว่างการแข่งขัน "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* "),
          /*#__PURE__*/_createElementVNode("b", null, "นักธุรกิจแอมเวย์รหัสคู่มีสิทธิเข้าร่วมแข่งขันได้ทั้ง 2 ท่าน"),
          /*#__PURE__*/_createTextVNode(" โดยต้องสมัครอยู่ทีมเดียวกันเท่านั้น เนื่องจากการนับคะแนน จากการสปอนเซอร์จะนับต่อรหัสเท่านั้น "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* ผู้เข้าแข่งขัน 1 ท่านมีสิทธิ์เข้าร่วมได้เพียง 1 ทีมเท่านั้น "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode("* หากมีสมาชิกในทีมลาออกจากการแข่งขัน ลาออกจากธุรกิจแอมเวย์ หรือสิ้นสุดสถานภาพนักธุรกิจแอมเวย์ สงวนสิทธิไม่รับสมาชิกใหม่เข้ามาทดแทน ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "button-section desktop",
        style: {"margin":"48px 0 104px"}
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "video-size" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "video-box" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            width: "100%",
            height: "100%",
            src: "https://www.youtube.com/embed/dNijm4IRl5M",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          })
        ])
      ])
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<section id=\"reward\" style=\"margin-top:-180px;padding-top:180px;\"><div class=\"reward-section\"><div style=\"max-width:1276px;margin:0 auto;\"><div class=\"ribbon\"><img src=\"" + _imports_18 + "\"><div class=\"ribbon-text\">แจกรางวัลทุกสัปดาห์</div></div><div class=\"weekly-reward\"><div class=\"weekly-reward-text\"> ของรางวัลรายสัปดาห์ <br><span>มูลค่ารวม 3,000,000 บาท</span></div><img src=\"" + _imports_19 + "\" width=\"100%\" height=\"auto\"></div><div class=\"weekly-reward-m\"><div class=\"weekly-reward-text\"> ของรางวัลรายสัปดาห์ <br><span>มูลค่ารวม 3,000,000 บาท</span></div><img src=\"" + _imports_20 + "\" width=\"100%\" height=\"auto\"></div></div><div class=\"winner-reward\"><div class=\"container\"><div class=\"winner-reward-title\"><div class=\"wrt-b\">รางวัลชนะเลิศและรางวัลชมเชย</div><div class=\"wrt-text\"> 70 ทีม ที่ได้คะแนนรวมสะสมตลอดทั้งโปรแกรม การแข่งขัน 70 วันจะได้รับรางวัลดังต่อไปนี้ </div><div class=\"wrt-green\">รวมมูลค่าของรางวัลชนะเลิศมูลค่า 4,000,000 บาท</div></div><div class=\"winner-reward-box\"><img src=\"" + _imports_21 + "\"><div class=\"wr-detail\"><div class=\"wr-title\">รางวัลชนะเลิศ 10 ทีม</div><div class=\"wr-sub-title\">(สำหรับทีมที่ได้คะแนนรวมสะสมสูงสุดลำดับ 1-10)</div><div class=\"wr-text\"> รับแพ็คเกจไปท่องเที่ยวทริปญี่ปุ่น เกียวโต โอซาก้า <br>พร้อมกับกูรูด้านการถ่ายภาพ สร้างคอนเทนต์แบบครีเอเตอร์โปร <div>มูลค่า 350,000 บาท/ทีม</div></div></div></div><div class=\"winner-reward-box\"><img src=\"" + _imports_22 + "\"><div class=\"wr-detail\"><div class=\"wr-title\">รางวัลชมเชย 60 ทีม</div><div class=\"wr-sub-title\">(สำหรับทีมที่ได้คะแนนรวมสะสมสูงสุดลำดับ 11-70)</div><div class=\"wr-text\"> รับกิ๊ฟท์เซตกล้องโพลารอยด์ครีเอเตอร์สุดเก๋ <div>ท่านละ 1 ชุด มูลค่า 1,600 บาท</div></div></div></div><div style=\"margin-top:48px;padding:0 16px;font-size:16px;font-weight:700;line-height:24px;text-align:center;\"> ผู้เข้าแข่งขันที่ได้รับรางวัล ซึ่งมีมูลค่ามากกว่า 1,000 บาท <br class=\"mobile\">มีหน้าที่ชำระภาษีหัก ณ ที่จ่าย 5% ของมูลค่าของรางวัล <br>ตามคำสั่งของกรมสรรพากรที่ ท.ป.101/2544 <br class=\"mobile\">โดยต้องชำระเป็นเงินสดเท่านั้น </div></div></div></div></section><section class=\"footer\"><div class=\"container\"><div class=\"row mx-0\"><div class=\"footer-logo\"><img src=\"" + _imports_23 + "\" height=\"40px\"></div><div class=\"footer-address\"> บริษัท แอมเวย์ (ประเทศไทย) จำกัด <br>1199/1 ถนนรามคำแหง แขวงหัวหมาก เขตบางกะปิ กรุงเทพ ฯ 10240 </div><div class=\"footer-call\"><div class=\"footer-call-text\">ต้องการความช่วยเหลือ ?</div><div class=\"footer-call-phone\"><img src=\"" + _imports_24 + "\"><a href=\"tel:+0-2725-8000\">0-2725-8000</a></div></div><div class=\"copy-right\">Copyright 2022, Amway (Thailand) Ltd,.</div></div></div></section>", 2)
const _hoisted_9 = {
  class: "popup show",
  id: "choose-account"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "popup-bg" }, null, -1)
const _hoisted_11 = { class: "popup-content-area" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "main-popup-content",
  style: {"height":"250px"}
}, [
  /*#__PURE__*/_createElementVNode("h4", null, "การลงชื่อเข้าใช้ถูกบล็อค"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, "บัญชีของคุณถูกระงับเนื่องจากไม่มีการเคลื่อนไหวในระบบเป็นเวลานาน กรุณาติดต่อ Amway Contact Center"),
  /*#__PURE__*/_createElementVNode("div", { class: "button-group" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn-solid btn-confirm",
      onclick: "location.href='https://www.amway.co.th';"
    }, "รับทราบ")
  ])
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "popup-title" }
const _hoisted_15 = { class: "popup-title" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" กรุณาเลือกบัญชีของคุณ ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("ที่ต้องการเข้าร่วมกิจกรรม ")
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "popup-content-choice" }
const _hoisted_21 = ["value", "id"]
const _hoisted_22 = ["for"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "label-check-radio" }, null, -1)
const _hoisted_24 = { class: "label-detail" }
const _hoisted_25 = { class: "label-name" }
const _hoisted_26 = { class: "label-id" }
const _hoisted_27 = ["value", "id"]
const _hoisted_28 = ["for"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "label-check-radio" }, null, -1)
const _hoisted_30 = { class: "label-detail" }
const _hoisted_31 = { class: "label-name" }
const _hoisted_32 = { class: "label-id" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, "ยืนยัน", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, "ยืนยัน", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { style: {"text-align":"center"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  style: {"margin-bottom":"15px"},
  class: "popup-title"
}, "กรุณารอสักครู่...", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  height: "35",
  src: _imports_25,
  alt: ""
}, null, -1)
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { style: {"text-align":"center","margin-top":"40px"} }
const _hoisted_42 = {
  style: {"margin-bottom":"15px","font-size":"18px","line-height":"1.3em"},
  class: "popup-title"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" เสียใจด้วย... ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Creators challenge ")
const _hoisted_47 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_6,
    _hoisted_7,
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("div", null, _hoisted_13, 512), [
          [_vShow, _ctx.isLoaded && _ctx.isUserInactive]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _withDirectives(_createElementVNode("div", _hoisted_14, " กรุณาเลือกบัญชีของคุณ ", 512), [
            [_vShow, _ctx.accounts.length != 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_19, 512), [
            [_vShow, _ctx.accounts.length == 0]
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "custom-radio",
                style: {"margin-right":"0","height":"auto","padding":"0","width":"100%"},
                key: account.accountId
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                  value: account.accountId,
                  type: "radio",
                  name: "account",
                  id: account.accountId
                }, null, 8, _hoisted_21), [
                  [_vModelRadio, _ctx.selectedAccount]
                ]),
                _createElementVNode("label", {
                  for: account.accountId
                }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(account.accountName), 1),
                    _createElementVNode("div", _hoisted_26, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(account.accountId), 1)
                  ])
                ], 8, _hoisted_22)
              ])), [
                [_vShow, _ctx.accounts.length !== 0]
              ])
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (member) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "custom-radio",
                style: {"margin-right":"0","height":"auto","padding":"0","width":"100%"},
                key: member.id
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUser) = $event)),
                  value: member.id,
                  type: "radio",
                  name: "member",
                  id: member.id
                }, null, 8, _hoisted_27), [
                  [_vModelRadio, _ctx.selectedUser]
                ]),
                _createElementVNode("label", {
                  for: member.id
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(member.name), 1),
                    _createElementVNode("div", _hoisted_32, "รหัสนักธุรกิจแอมเวย์ " + _toDisplayString(_ctx.aboId), 1)
                  ])
                ], 8, _hoisted_28)
              ])), [
                [_vShow, _ctx.accounts.length == 0]
              ])
            }), 128))
          ]),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "w-100 btn-red btn-i-confirm",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectAccount && _ctx.selectAccount(...args)))
          }, _hoisted_34, 512), [
            [_vShow, _ctx.accounts.length !== 0]
          ]),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "w-100 btn-red btn-i-confirm",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectUser && _ctx.selectUser(...args)))
          }, _hoisted_36, 512), [
            [_vShow, _ctx.accounts.length == 0]
          ])
        ], 512), [
          [_vShow, _ctx.isLoaded && !_ctx.isUserInactive]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_37, _hoisted_40, 512), [
          [_vShow, !_ctx.isLoaded]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _hoisted_44,
            _createTextVNode(" บัญชี " + _toDisplayString(_ctx.selectedUser) + " ไม่ได้เข้าร่วมกิจกรรม ", 1),
            _hoisted_45,
            _hoisted_46
          ])
        ], 512), [
          [_vShow, _ctx.isLoaded && !_ctx.isRegistered]
        ])
      ])
    ]),
    _createElementVNode("iframe", {
      id: "iframe",
      ref: "iframe",
      onLoad: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAccessToken(this))),
      sandbox: "allow-same-origin allow-scripts allow-popups allow-forms",
      style: {"width":"1px","height":"1px"},
      src: _ctx.authSSO
    }, null, 40, _hoisted_47)
  ]))
}